import type { FilterItemPascal, SerializedFile } from "../index";

import { ComplaintCallAttemptEnum } from "../enums/complaintCallAttemptEnum";
import { ComplaintCustomerContactEnum } from "../enums/complaintCustomerContactEnum";
import { ComplaintLOAStatusEnum } from "../enums/complaintLOAStatusEnum";

export interface RepIncident {
	id: number;
	representativeId: number;
	enrollmentId?: number;
	incidentDate: Date;
	valid?: boolean;
	invalidReason: string;

	createdOn: Date;
	updatedOn: Date;
	dueDate?: Date;
	sentDate?: Date;

	qaAnalystId: number;
	qaAnalystName: string;
	assignedDate: Date;
	status: IncidentStatus;
	statusId: number;
	statusName: string;

	actionTakenId: string;
	actionTakenName: string;
	enrollmentDate?: Date;
	esidNumber: string;
	ucid: string;
	loaStatus: ComplaintLOAStatusEnum;
	loaStatusId?: number;
	loaStatusName: string;

	qaConversationWithCustomer: string;
	qaActionOnBehalfOfCustomer: string;
	agentDescriptionOfIncident: string;
	personSpokenTo: string;
	customerPhoneNumber: string;
	customerName: string;
	customerAddress: string;
	qaCoachingDetail: string;
	investigationFindings: string;
	gpsSubmissionAddress: string;

	customerContactType?: ComplaintCustomerContactEnum;
	customerContactTypeId?: number;
	customerContactTypeName: string;

	customerCallAttempt?: ComplaintCallAttemptEnum;
	customerCallAttemptId?: number;
	customerCallAttemptName: string;

	completedDate?: Date;
	representativeLogin: string;
	representativeFirstName: string;
	representativeLastName: string;
	representativeFullName: string;

	documentsUploaded?: SerializedFile[];

	channel: string;
	branch: string;
	branchId?: number;
	brand: string;
	vendor: string;
	repActive?: boolean;
}

export interface IncidentHistory {
	id: number;
	incidentId: number;
	timestamp: Date;
	message: string;
	userId: number;
	userName: string;
	status: IncidentStatus;
}

export interface ActionTakenCategories extends FilterItemPascal {
	SubCategories: FilterItemPascal[];
}

export enum IncidentStatus {
	Open = 0,
	Pending = 1,
	Completed = 2,
}
